import FormInputField from "@/components/lib/from-input-field";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { ButtonType } from "@/components/lib/Button";
import { useState } from "react";
import CreateAddonsDialog from "@/components/dialog/menu-manage/common-dialog/create-addons";

function Step2({ form, menu_id }) {

  const { days } = useSelector((state) => state.utility.day);
  const { addOns } = useSelector((state) => state.essentialMenu.addOns);
  const [createNewAddsOns, setCreateNewAddsOns] = useState(false);

  const closeAddOns = () => {
    setCreateNewAddsOns(false);
  };
  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {form.watch("type") == "update"
            ? "Update Dish of the day"
            : "Add New Dish of the day"}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-5 mt-5">
          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <FormInputField
                  name="price"
                  style="bg-cblack7 h-10"
                  placeholder={"Price"}
                  form={form}
                  type="text"
                  label={"Price"}
                />
              </div>
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full mt-3">
                <FormInputField
                  name="add_ons"
                  type="multiselect"
                  label="Add Ons"
                  style="w-full bg-cblack7"
                  placeholder="Select Add Ons"
                  selectOption={
                    addOns && addOns?.length > 0
                      ? addOns
                        .filter((item) => item?.status === "active")
                        .map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))
                      : [
                          {
                            label: "No brand available",
                            value: "",
                            disabled: true,
                          },
                        ]
                  }
                  form={form}
                />
              </div>
              <ButtonType
                onClick={() => setCreateNewAddsOns(true)}
                className="bg-cgreen/50 text-cwhite"
              >
                Create New Add-ons
              </ButtonType>
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <FormInputField
                  name="day_id"
                  style="bg-cblack7 h-10"
                  placeholder={"Selete a day"}
                  clearable={true}
                  form={form}
                  type="select"
                  selectOption={days?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  label={"Day"}
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
      {/* all dialog */}
      <CreateAddonsDialog
        menu_id={menu_id}
        title={"Create New Add-ons"}
        onClose={closeAddOns}
        isOpen={createNewAddsOns}
      />
    </Card>
  );
}

export default Step2;
